import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocations = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3946 20.0442C13.8813 21.5859 12.614 22.5382 12.4808 22.6352L12.0005 22.9903L11.5202 22.6352C11.387 22.5382 10.1198 21.5859 8.60636 20.0442C7.4724 20.4155 6.75391 20.9643 6.75391 21.5817C6.75391 22.6955 9.10273 23.5996 12.0003 23.5996C14.8979 23.5996 17.2467 22.6955 17.2467 21.5817C17.2467 20.9643 16.5243 20.4153 15.3943 20.0442H15.3946Z",
			fill: "inherit"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0001 21.9856C12.0001 21.9856 20.0715 16.0289 20.0715 9.0714C20.0715 4.61589 16.4556 1 12.0001 1C7.5446 1 3.92871 4.61589 3.92871 9.0714C3.92871 16.0289 12.0001 21.9856 12.0001 21.9856ZM5.94656 9.0714C5.94656 5.73385 8.66256 3.01785 12.0001 3.01785C15.3377 3.01785 18.0537 5.73385 18.0537 9.0714C18.0537 12.4089 15.3377 15.1249 12.0001 15.1249C8.66256 15.1249 5.94656 12.4089 5.94656 9.0714Z",
			fill: "inherit"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2233 12.6801L13.9402 9.25095C14.026 9.07388 14.0204 8.86237 13.9172 8.69652C13.8142 8.53068 13.6311 8.42786 13.4307 8.42786H11.4965L12.8012 5.82749C12.9443 5.54734 12.8298 5.20443 12.5437 5.06152C12.2575 4.91862 11.9198 5.03295 11.7767 5.31871L10.0598 8.74781C9.97396 8.92488 9.97958 9.13639 10.0828 9.30223C10.1858 9.46808 10.3689 9.5709 10.5693 9.5709H12.5035L11.1988 12.1713C11.0557 12.4514 11.1702 12.7943 11.4563 12.9372C11.5365 12.9773 11.628 13 11.7138 13C11.9256 13 12.1259 12.8857 12.2289 12.6857L12.2233 12.6801Z",
			fill: "inherit"
		})
	]
});
export { SvgLocations as ReactComponent };
